import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TopNav from "../../components/top-nav";
import BusinessInfoSection from "../../components/BusinessInfoSection";
import BusinessFormSection from "../../components/BusinessFormSection";

const BecomeBusinessPage = () => {
  const user = useSelector((state) => state.userProfile.dataFetched);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    if (user) {
      setShowForm(!!user.business);
    }
  }, [user]);

  return (
    <>
      <TopNav title="My business portal" hideRightIcon />
      <div
        className="contain display-main-content !pt-32 h-screen"
        style={{ paddingTop: "2rem", paddingBottom: "2rem" }}
      >
        {!showForm ? (
          <BusinessInfoSection onContinue={() => setShowForm(true)} />
        ) : (
          <BusinessFormSection user={user} />
        )}
      </div>
    </>
  );
};

export default BecomeBusinessPage;
